// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__8YLUh","signatureBlock":"Footer_signatureBlock__22zIO","signature":"Footer_signature__1b47_"};